import {
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  makeStyles,
  Typography,
} from '@material-ui/core';
import Box from '@mui/material/Box';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ErrorMessage from '../../../../Common/ErrorMessage';
import BackgroundTheme from '../../../../Common/P2P/Header/BackgroundTheme';
import RoundButton from '../../../../Common/RoundButton';
import PopUpDialogBox from '../../../../shared/PopUpDialogBox';
import { AppState } from '../../../../store/rootReducer';
import Curerncy from '../../../../utils/assests/currency.svg';
import {
  getWithDrawableAmount,
  removeWithDrawableAmount,
  setWithDrawableAmount,
} from '../../../../utils/localStorage';
import { getAddMoneyValue } from '../../InvestFund/investFundAction';
import { resetWithdrawal, withdrawMoney } from '../dashboardAction';
import WithdrawalPopSucess from '../../../../utils/assests/withdrawalSuccess.png';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiFilledInput-root': {
      background: 'rgb(232, 241, 250)',
    },
    '& .Mui-focused': {
      color: 'tomato',
      fontWeight: 'bold',
    },
  },
}));

const WithdrawMoney = () => {
  let history = useHistory();
  let dispatch = useDispatch();
  const [withdrawAmount, setWithdrawAmount] = useState<any>(
    getWithDrawableAmount('withdrawAmount')
  );
  const { dashboardSummary } = useSelector(
    (state: AppState) => state.dashboard
  );
  const [error, setError] = useState<any>(false);
  // const [popupDialogOpen, setDialogOpen] = useState<boolean>(false);
  const [amount, setAmount] = useState<any>('');
  const classes = useStyles();

  const addWithdrawAmount = (e: any) => {
    const { value } = e.target;
    dispatch(getAddMoneyValue(value));
    setAmount(value);
  };

  const confirmWithdraw = () => {
    removeWithDrawableAmount('withdrawAmount');
    dispatch(withdrawMoney());
  };
  const { withdrawResponse } = useSelector((state: any) => state.dashboard);
  const [message, setMessage] = useState<any>('');

  useEffect(() => {
    if (withdrawResponse?.status) {
      setMessage(withdrawResponse?.results?.message);
      if (withdrawResponse?.status && withdrawResponse?.results) {
        history.push({ pathname: '/p2p/withdrawalSuccess' });
        dispatch(resetWithdrawal());
        // return setDialogOpen(true);
      }
    }
  }, [withdrawResponse]);
  useEffect(() => {
    document.title = 'stashearn - withdraw money';
  }, []);

  // const handleClose = () => {
  //   setDialogOpen(!popupDialogOpen);
  // };
  // const handleYes = () => {
  //   history.push({ pathname: '/p2p/dashboard' });
  // };
  return (
    <BackgroundTheme>
      <Card className='redBorder widhdrawCard'>
        <CardContent>
          <Box className='addMoney'>
            <Typography variant='h4'>Enter amount to withdraw</Typography>
            <Box className='addMoneyBox'>
              <FormControl fullWidth variant='standard'>
                <Input
                  type='number'
                  id='investment_amount'
                  inputProps={{
                    min: 1000,
                    max: 1000000,
                    style: {
                      textAlign: 'center',
                      color: '#000066',
                      fontWeight: 'bold',
                      fontSize: '22px',
                      border: 'none',
                      marginBottom: '0',
                    },
                  }}
                  onKeyDown={(e) =>
                    ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
                  }
                  // startAdornment={
                  //   <InputAdornment position='start'>
                  //     <img src={Curerncy} alt='currency logo' width={18} />
                  //   </InputAdornment>
                  // }
                  className={classes.root}
                  value={amount}
                  name='amount'
                  onChange={(e) => addWithdrawAmount(e)}
                  autoFocus
                  autoComplete='off'
                />
                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                  {amount !== '' ? (
                    parseInt(amount) > parseInt(withdrawAmount) ? (
                      <Typography
                        component='span'
                        className={
                          parseInt(amount) > parseInt(withdrawAmount)
                            ? 'inputInfoText'
                            : ''
                        }
                      >
                        max. withdrawable amount <span>₹ {withdrawAmount}</span>
                      </Typography>
                    ) : (
                      ''
                    )
                  ) : null}
                </Box>
                {error && (
                  <Typography
                    align='center'
                    style={{ color: '#ff0028', marginTop: '10px' }}
                  >
                    Invalid amount
                  </Typography>
                )}
              </FormControl>
            </Box>
          </Box>
          {message !== '' ? <ErrorMessage text={message} /> : ''}
          <div>
            <RoundButton
              title='Continue'
              onClick={() => confirmWithdraw()}
              // disable={
              //   amount === '' || parseInt(amount) > parseInt(withdrawAmount)
              // }
            />
          </div>

          {/* <PopUpDialogBox
            toggle={popupDialogOpen}
            handleClose={handleClose}
            image={WithdrawalPopSucess}
            handleYes={handleYes}
            buttonTitle='Back to dashboard'
            success={true}
          /> */}
        </CardContent>
      </Card>
    </BackgroundTheme>
  );
};

export default WithdrawMoney;
